<template>
  <!-- Gift Card Checkout Detail start -->
  <div>
    <div class="checkout-cart-row">
      <div class="checkout-card-type-mobile">
        {{ $vuetify.lang.t("$vuetify.checkout.digitalEGiftCard") }}
      </div>
      <gift-card-design
        variant="compact"
        :design-code="cardDetails.designCode"
      />
      <div class="checkout-cart-info">
        <div class="checkout-card-type-desktop">
          {{ $vuetify.lang.t("$vuetify.checkout.digitalEGiftCard") }}
        </div>
        <div class="checkout-subtotal">
          <div class="checkout-subtotal-label">
            {{ $vuetify.lang.t("$vuetify.checkout.subtotal") }}
          </div>
          <div class="checkout-subtotal-amount">
            {{ getAmount | currency(true) }}
          </div>
        </div>
      </div>
    </div>
    <spacer size="m" border-bottom></spacer>
    <spacer size="m"></spacer>
    <template v-if="getBonusByAmount && getBonusByAmount.bonusCash > 0">
      <section class="fw-bold start-xs">
        {{ $vuetify.lang.t("$vuetify.checkout.bonus") }}
      </section>
      <div class="checkout-detail-row">
        <span class="fs-s fc-black"
          >{{ getBonusByAmount.bonusCash | currency(true) }}
          {{ $vuetify.lang.t("$vuetify.checkout.bonus") }}</span
        >
        <span class="checkout-bonus-value"
          >+ {{ getBonusByAmount.bonusCash | currency(true) }}</span
        >
      </div>
      <spacer size="l" border-bottom></spacer>
      <spacer size="l"></spacer>
    </template>
    <section class="fw-bold fs-m">
      {{ $vuetify.lang.t("$vuetify.checkout.yourGiftCardDetails") }}
    </section>
    <spacer size="m"></spacer>
    <div class="checkout-gift-details">
      <div class="checkout-detail-row">
        <span class="fs-s fc-black fw-bold">
          {{ $vuetify.lang.t("$vuetify.checkout.to") }}
        </span>
        <span class="fs-xs fc-black">
          <span style="margin-right: 4px;">{{ cardDetails.receiverName }}</span>
          <template v-if="cardDetails.receiverEmail">
            ({{ cardDetails.receiverEmail }})
          </template>
          <template v-else-if="cardDetails.receiverMobile">
            ({{ cardDetails.receiverMobile | phoneNumber }})
          </template>
        </span>
      </div>
      <template v-if="cardDetails.senderName">
        <spacer size="s"></spacer>
        <div class="checkout-detail-row">
          <span class="fs-s fc-black fw-bold">
            {{ $vuetify.lang.t("$vuetify.checkout.from") }}
          </span>
          <span class="fs-xs fc-black">{{ cardDetails.senderName }}</span>
        </div>
      </template>

      <template v-if="cardDetails.customMessage">
        <spacer size="s"></spacer>
        <div>
          <div class="fs-s fc-black fw-bold">
            {{ $vuetify.lang.t("$vuetify.checkout.personalizedMessage") }}
          </div>
          <div class="fs-xs fc-black checkout-message">
            {{ cardDetails.customMessage }}
          </div>
        </div>
      </template>
    </div>
    <spacer size="m" border-bottom></spacer>
  </div>
  <!-- Gift Card Checkout Detail end -->
</template>

<script>
import GiftCardDesign from "../../feature/GiftCardDesign.vue";
import Spacer from "../../common/Spacer.vue";

export default {
  name: "gift-card-review",
  components: {
    GiftCardDesign,
    Spacer,
  },
  props: {
    cardDetails: {
      type: Object,
      required: true,
    },
    getAmount: {
      type: Number,
      required: true,
    },
    getBonusByAmount: {
      type: Object,
      required: false,
      default: null,
    },
  },
};
</script>
